function SettingsRow({ label, description, htmlFor, alignTop = false, children }) {
  return (
    <div className={`settings-row ${alignTop ? "settings-row--top" : ""}`}>
      <div className="settings-row-text">
        <label className="settings-label" htmlFor={htmlFor}>
          {label}
        </label>

        {description ? (
          <p className="settings-help">{description}</p>
        ) : null}
      </div>

      <div className="settings-row-control">
        {children}
      </div>
    </div>
  );
}

export default SettingsRow;